export const survey: SurveySetup = {
    background: '/assets/images/background.png',
    illustration: '/assets/images/truck-illustration.png',
    illustrationAlt: 'Banker and coach in front of food truck',
    tagline: 'Thanks for completing the Innovation Accounting Simulation',
    title: 'Turn your next move into a business case.',
    text: `<p>Krobar helps you model uncertainty, compare scenarios, and explain your next growth move with confidence.</p>
            <p>If you have one minute, share feedback on the simulation so we can keep improving it.</p>`,
    buttonLabel: 'Share feedback',
    buttonLink: 'https://docs.google.com/forms/d/e/1FAIpQLSdne982dkIoF962miftBFcRgcUc2-CUohlZaoWEEhGiWtudVA/viewform?usp=sf_link',
    krobarCta: {
        buttonLabel: 'Try Krobar.ai free',
        buttonLink: 'https://krobar.ai',
        chart: '/assets/images/krobar-hurricane-chart.png',
        chartAlt: 'Krobar forecast chart',
        logo: '/assets/images/krobar-black.svg',
        logoAlt: 'Krobar logo',
        text: 'Krobar helps you quantify impact, model risk, and present stakeholder-ready decisions.',
        title: 'Ready to pressure-test your next growth move?',
    },
};
